import React, { useEffect, useState } from 'react';

import { Input } from '@eika/input';

import useTranslation from '../../../../hooks/useTranslation';
import { CrossBorderPaymentActionType } from '../form/actions';
import useFormContext from '../form/useFormContext';
import { receiverError, validateNationalIdNumber } from '../form/validate';

interface Props {
    value?: string;
    validationError?: receiverError;
    setValidationError: (errors: receiverError) => void;
}

const NationalIdInput: React.FC<Props> = ({ value, validationError, setValidationError }) => {
    const translated = useTranslation();
    const { state, handleChange } = useFormContext();
    const [nationalId, setNationalId] = useState<string>(state.receiver?.nationalId?.value || '');
    const [nationalIdError, setNationalIdError] = useState<string | undefined>();

    useEffect(() => {
        if (value) {
            setNationalId(value);
            handleChange({
                type: CrossBorderPaymentActionType.SET_RECEIVER_NATIONAL_ID,
                payload: { value },
            });
        } else {
            setNationalId(state.receiver?.nationalId?.value ?? '');
        }
    }, [handleChange, state.receiver?.nationalId?.value, value, setNationalId]);

    const validateNationalId = (nationalIdNumber: string) => {
        const validation = validateNationalIdNumber(translated, nationalIdNumber, state);
        setNationalIdError(validation?.nationalId);

        if (!validation) {
            handleChange({
                type: CrossBorderPaymentActionType.SET_RECEIVER_NATIONAL_ID,
                payload: { value: nationalIdNumber },
            });
            handleChange({
                type: CrossBorderPaymentActionType.SET_RECEIVER_ACCOUNT_TYPE,
                payload: 'BBAN',
            });
            if (!state.receiver?.bic) {
                handleChange({
                    type: CrossBorderPaymentActionType.SET_NEED_BIC,
                });
            }
        }
        if (validation && !value) {
            handleChange({ type: CrossBorderPaymentActionType.SET_RECEIVER_NATIONAL_ID });
            handleChange({ type: CrossBorderPaymentActionType.SET_RECEIVER_ACCOUNT_TYPE });
        }
    };

    return (
        <Input
            className="cross-border-payment__field-top"
            label={translated.crossBorderPayment.newReceiver.nationalIdLabel}
            value={nationalId}
            type="tel"
            onChange={(value) => {
                if (value.target.value.length === state.country?.nationalIdRequirements?.length) {
                    validateNationalId(value.target.value);
                }
                setNationalId(value.target.value);
                setValidationError({ nationalId: undefined });
            }}
            onBlur={() => validateNationalId(nationalId)}
            error={nationalIdError || validationError?.nationalId}
        />
    );
};

export default NationalIdInput;
